<template>
  <b-container>
    <h1 class="title text-center">Deals</h1>

    <div
      v-if="isLoading"
      class="loader"
    >
      <b-spinner variant="primary" label="Spinning"></b-spinner>
    </div>

    <b-row v-show="!isLoading">
      <div class="text-center col-12">
        <p v-if="deals.length == 0">No deals yet!</p>
      </div>

      <div
        v-for="deal in deals"
        :key="deal.id"
        class="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-sx-12 my-3"
      >
        <b-card>
          <b-img-lazy blank="true" :blank-src="require('../assets/images/eclipse.gif')" :src="deal.attributes.image_url" alt="Menuitem"></b-img-lazy>

          <div class="p-3 font-lighter">
            <p style="font-size: 20px;">{{ deal.attributes.name }}</p>
            <div class="cut-line">
              <ins>
                <span>Price: ${{ deal.attributes.deal_price }}</span>
              </ins>

              <del class="float-right">
                <span>$ {{ deal.attributes.price }}</span>
              </del>
            </div>
            <p v-if="deal.attributes.limited_time_offer">Time: {{ deal.attributes.offer_start_time | moment("h:mm A") }} - {{ deal.attributes.offer_end_time | moment("h:mm A") }}</p>
            <div class="border-top text-center pt-2">
              <button class="show-btn ripple" @click="showDeal(deal.id)">Show</button>
            </div>
          </div>
        </b-card>
      </div>
    </b-row>
  </b-container>
</template>

<script>
import { getDeals } from '../store/api'
import Card from "../components/card";

export default {
  name: "deals",

  components: {
    'deal-card': Card,
  },

  data() {
    return {
      isLoading: true,
      deals: [],
    }
  },

  created() {
    getDeals()
      .then(response => {
        this.deals = response.data
        this.isLoading = false
      })
      .catch(erorr => {
        this.isLoading = false
        this.$notify({
          type: 'error',
          text: "Something went wrong. Please try again by refreshing page."
        })
      })
  },

  methods: {
    showDeal(deal_id) {
      this.$router.push(`deals/${deal_id}`)
    },
  },

  beforeCreate: function() {
    document.body.className = '';
  },
}
</script>

<style scoped>
  .row {
    justify-content: left;
  }
  img {
    width: 100%;
    height: 200px;
    object-fit: cover;
    border-top-left-radius: 15px;
    border-top-right-radius: 15px;
  }
  .card {
    border-radius: 15px;
  }
  .card-body {
    padding: 0px;
  }
  .show-btn {
    padding: 5px;
    width: 100%;
    border: none;
    color: #5663FF;
  }
  .show-btn:focus {
    outline:0;
  }
  .ripple {
    background-position: center;
    transition: background 0.8s;
  }
  .ripple:hover {
    background: #e9ecef radial-gradient(circle, transparent 1%, #e9ecef 1%) center/15000%;
  }
  .ripple:active {
    background-color: rgb(228, 228, 228);
    background-size: 100%;
    transition: background 0s;
  }
  .cut-line del {
    color: #707070;
    text-decoration: none;
    position: relative;
    font-size: 17px;
    font-weight: 100;
  }
  .cut-line del:after {
    content: "";
    display: block;
    width: 100%;
    border-top: 1px solid #707070;
    height: 4px;
    position: absolute;
    bottom: 10px;
    left: 0;
  }
  .cut-line ins {
    text-decoration: none;
  }
</style>
